export const COMMONVIEW_TYPES = {
  BIOLIFE_LOGO_BLOCK: 'biolifeLogoBlock',
  APP_STORE_LOGOS_BLOCK: 'appStoreLogosBlock',
  SUBSCRIPTION_BOX_BLOCK: 'subscriptionBoxBlock',
  TRADEMARK_STATEMENT_BLOCK: 'trademarkStatementBlock',
  SOCIAL_MEDIA_ICONS_BLOCK: 'socialMediaIconsBlock'
}

export default { COMMONVIEW_TYPES }
